import { AuthorizedFetch } from "../context/AppSessionContext";
import { ClientCompany, PaginatedResponse } from "../types/clientCompanies";
import { readErrorMessage } from "./http";

// The API caps a page at 100, so dropdowns walk every page to list all companies.
const pageLimit = 100;

/** Active client companies, sorted by name, across all pages. */
export const fetchAllClientCompanies = async (
  authorizedFetch: AuthorizedFetch,
): Promise<ClientCompany[]> => {
  const companies: ClientCompany[] = [];
  let page = 1;
  let totalPages = 1;

  do {
    const response = await authorizedFetch(
      `/client-companies?page=${page}&limit=${pageLimit}`,
    );

    if (!response.ok) {
      throw new Error(
        await readErrorMessage(
          response,
          `Failed to load client companies (${response.status}).`,
        ),
      );
    }

    const payload = (await response.json()) as PaginatedResponse<ClientCompany>;
    companies.push(...(payload.data ?? []));
    totalPages = payload.totalPages ?? 1;
    page += 1;
  } while (page <= totalPages);

  return companies;
};
